import BaseStore from '../../base-store'

let options = {}
export default new BaseStore('event-categories', options)



// WEBPACK FOOTER //
// ./src/store/modules/configuration/event-categories.store.js